<template>
  <div class="container">
    <div id="card-box" class="card-box">
      <img class="bg" src="@/assets/pic/fg_workcard.png" />
      <img class="photo" :style="{marginLeft:`${windowWidth/2-70}px`}" :src="photo" />
      <div class="sub-company">{{ subCompany }}</div>
      <div class="name">{{ empName }}</div>
      <div class="duty">{{ duty }}</div>
      <div class="code">{{ empCode }}</div>
    </div>
    <div style="height:10px"></div>
    <div id="bg-card-box" class="bg-card-box">
      <img class="bg" src="@/assets/pic/bg_workcard.png" />
      <!-- <img class="qr-code"  /> -->
    </div>
    <!-- <div class="func-area">
      <el-button type="primary" @click="browserPrint">打印</el-button>
      <el-button type="primary" @click="generaPdf">生成PDF</el-button>
      <el-alert title="生成PDF需要先等待照片加载完成" type="info"></el-alert>
    </div> -->
  </div>
</template>

<script>
// import html2Canvas from "html2canvas";
// import JsPDF from "jspdf";
import request, { getEmployees } from "@/utils/request";

// const settings = require("@/utils/settings.js");

export default {
  layout: "blank",
  head() {
    return {
      title: "工作证-"
    };
  },
  components: {},
  data() {
    return {
      windowWidth: 0,
      empName: "",
      empCode: "",
      subCompany: "",
      duty: "",
      photo: "",
      id: NaN
    };
  },
  mounted() {
    this.windowWidth = document.body.clientWidth
    getEmployees({
      empName: this.$route.query.empName,
      empCode: this.$route.query.empCode
    }).then(({ data }) => {
      this.empName = data.empName;
      this.empCode = data.empCode;
      this.duty = data.duty;
      this.subCompany = data.subCompany;
      //this.photo = settings.web_base_url + res.photo;
      this.photo = data.photoBase64;
    });
  },
  methods: {
    browserPrint() {
      window.print();
    },
    // generaPdf() {
    //   html2Canvas(document.querySelector("#card-box"), {
    //     useCORS: false, //（图片跨域相关）
    //     allowTaint: true, //允许跨域（图片跨域相关）
    //     width: 562,
    //     height: 798,
    //     windowWidth: 1905
    //   }).then(function(canvas) {
    //     var pageData = canvas.toDataURL("image/jpeg", 1.0);
    //     let PDF = new JsPDF("", "pt", "a4");

    //     PDF.addImage(pageData, "JPEG", 122, 5, 375, 542);

    //     PDF.save("工作证正面.pdf");
    //   });

    //   html2Canvas(document.querySelector("#bg-card-box"), {
    //     useCORS: true, //（图片跨域相关）
    //     allowTaint: false, //允许跨域（图片跨域相关）
    //     width: 562,
    //     height: 798,
    //     windowWidth: 1905
    //   }).then(function(canvas) {
    //     var pageData = canvas.toDataURL("image/jpeg", 1.0);
    //     let PDF = new JsPDF("", "pt", "a4");

    //     PDF.addImage(pageData, "JPEG", 122, 10, 375, 532);

    //     PDF.save("工作证背面.pdf");
    //   });
    // }
  }
};
</script>

<style>
.container {
  margin: 0 auto;
  padding: 10px 0 0 0;
  height: auto;
}
.card-box {
  margin: 0 auto;
  width: 100%;
  height: 578px;
  position: relative;
  padding: 0;
}
.bg-card-box {
  margin: 10px auto 0 auto;
  width: 100%;
  height: 598px;
  position: relative;
  padding: 0;
}
.bg {
  width: 100%;
  height: 568px;
  position: absolute;
  z-index: 1;
}

.sub-company {
  margin: 100px 0 0 0;
  position: absolute;
  display: inline-block;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 24px;
  z-index: 2;
}

.photo {
  width: 140px;
  margin-left: 115px;
  margin-top: 220px;
  position: absolute;
  z-index: 2;
}
.name {
  margin: 430px 0 0 130px;
  position: absolute;
  display: inline-block;
  width: 168px;
  text-align: center;
  z-index: 2;
}
.duty {
  margin: 450px 0 0 130px;
  position: absolute;
  display: inline-block;
  width: 168px;
  text-align: center;
  z-index: 2;
}
.code {
  margin: 473px 0 0 130px;
  position: absolute;
  display: inline-block;
  width: 168px;
  text-align: center;
  z-index: 2;
}
.qr-code {
  width: 220px;
  height: 220px;
  margin-left: 170px;
  margin-top: 479px;
  position: absolute;
  z-index: 2;
  opacity: 0.4;
}

.func-area {
  margin: 80px auto;
  text-align: center;
  position: fixed;
  left: 20px;
  bottom: 20px;
}

@media print {
  @page {
    margin-bottom: 0mm;
    margin-top: 0mm;
  }

  .func-area {
    visibility: hidden;
  }
}
</style>